import React from 'react';
import Stack, { StackProps } from 'src/app/atoms/Layout/Stack/Stack';
import CheckItemTextList, { CheckItemTextListProps } from './CheckItemTextList';

export interface CheckItemTextListWithActionsProps {
  checkItemTextListProps: CheckItemTextListProps;
  actions: React.ReactNode;
  gap?: StackProps['gap'];
  align?: StackProps['align'];
  justify?: StackProps['justify'];
  direction?: StackProps['direction'];
}

const CheckItemTextListWithActions = ({
  checkItemTextListProps,
  actions,
  gap = 'spacing-4xl',
  align = 'flex-start',
  justify = 'center',
  direction = 'column',
}: CheckItemTextListWithActionsProps): JSX.Element => (
  <Stack
    gap={gap}
    align={align}
    justify={justify}
    direction={direction}
  >
    <CheckItemTextList {...checkItemTextListProps} />
    {actions}
  </Stack>
);

export default CheckItemTextListWithActions;
